export const getBreadCrumb = (type, page, year, month, day) => {
  if (type === 'chart') {
    if (page === 'top') {
      return [{ text: '過去の天気（天気図）' }]
    } else if (page === 'month') {
      return [
        { text: '過去の天気（天気図）', link: '/onebox/past/chart/' },
        { text: `${year}年${Number(month)}月` }
      ]
    } else {
      return [
        { text: '過去の天気（天気図）', link: '/onebox/past/chart/' },
        { text: `${year}年${Number(month)}月`, link: `/onebox/past/chart/${year}/${month}/` },
        { text: `${Number(day)}日` }
      ]
    }
  }
}
